import { supabase } from "./supabase";
import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LangProvider } from "./LangContext";
import ErrorBoundary from "./components/ErrorBoundary";
import LoadingScreen from "./components/LoadingScreen";
import AuthScreen from "./components/AuthScreen";
import ResetPasswordScreen from "./components/ResetPasswordScreen";
import ProjectList from "./components/ProjectList";
import ProjectApp from "./components/ProjectApp";
import AdminDashboard from "./pages/AdminDashboard";

function AppInner() {
  const [session, setSession] = useState(undefined);
  const [profile, setProfile] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [resetMode, setResetMode] = useState(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => setSession(session));
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === "PASSWORD_RECOVERY") { setResetMode(true); setSession(session); return; }
      setSession(session);
      if (!session) { setProfile(null); setSelectedProject(null); setResetMode(false); }
    });
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    if (!session) return;
    supabase.from("profiles").select("*").eq("id", session.user.id).single()
      .then(({ data }) => { if (data) setProfile(data); });
  }, [session]);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setSelectedProject(null);
    setResetMode(false);
  };

  if (session === undefined) return <LoadingScreen />;
  if (resetMode) return <ResetPasswordScreen />;
  if (!session) return <AuthScreen />;
  if (!profile) return <LoadingScreen />;
  if (selectedProject) return <ProjectApp project={selectedProject} profile={profile} onBack={() => setSelectedProject(null)} onLogout={handleLogout} />;
  return <ProjectList profile={profile} onSelect={setSelectedProject} onLogout={handleLogout} />;
}

export default function App() {
  return (
    <BrowserRouter>
      <LangProvider>
        <ErrorBoundary>
          <Routes>
            <Route path="/admin/*" element={<AdminDashboard />} />
            <Route path="/*" element={<AppInner />} />
          </Routes>
        </ErrorBoundary>
      </LangProvider>
    </BrowserRouter>
  );
}
